module.exports = __webpack_public_path__ + "static/img/share_logo.f28d2ba.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/share_logo.png
// module id = RoO6
// module chunks = 57